import React, { Component } from 'react';
import { Typography, Table, Row, Button, Divider, Input, Spin, Tag, Badge, Collapse, Popconfirm, Select, message, Drawer, notification, Tooltip, Modal, Descriptions } from 'antd';
import { Link, Switch, Route } from 'react-router-dom';
import moment from 'moment';
import { defaultDateFormat, showErrorInNotification, THEME_COLORS, overrideHeaderBack, overrideHeaderTitle, formatMoney } from '../../lib/util';
import { RESTExecutor, withDomains } from '../../lib/domain';
import ErrorWrapper from '../../lib/error_wrapper';
import CustomDateRangePicker from '../../components/custom_date_range';
import { PopUpForm } from '../../lib/ui/popupform';
import FilesTransactions from './file_transactions';
import { BasicHeader } from '../../components/basic_header';
import FilterFixedInput from '../../components/filter_fixed_input';
import { TransparentButton, CustomButton } from '../../components/basic_items';
import { CloudUploadOutlined, GetAppOutlined, LayersOutlined, FlipOutlined, WifiTetheringOutlined, CloudDownloadOutlined, Refresh, AssignmentReturn, MoreHorizOutlined, FilterNone, StorageOutlined } from '@material-ui/icons';
import { COLORS } from '../theme';
import ModalTransactionDetail from '../../components/modal_transaction_detail';
import NetworkSelect from '../../lib/ui/network_select';


const { Panel } = Collapse;
const { Title, Paragraph, Text } = Typography;
const queryString = require('query-string');
const customPanelStyle = {
  background: '#FFFFFF',
  borderRadius: 6,
  marginBottom: 12,
  border: 0,
  overflow: 'hidden',
};

const transaction_cols_new = ({ onServiceClicked, onSourceClicked, onViewDetailClicked }) => [
  {
    title: "TYPE",
    dataIndex: "type",
    key: "type",
    className: 'center-align',
    width: 53,
    render: (value, row, index) => {
      return <div title={value == 'C' ? "Credit" : (value == 'D' ? "Debit" : "N/A")} className={value === 'D' ? 'debit-circle' : value == 'C' ? 'credit-circle' : 'na-circle'}>
        {value || "-"}
      </div>
    }
  }, {
    title: "TXN DATE",
    dataIndex: "txn_date",
    key: "txn_date",
    width: 100,
  }, {
    title: "TXN ID",
    dataIndex: "transaction_id",
    key: "transaction_id",
    width: 120,
  }, {
    title: "PARTICULARS ",
    dataIndex: "description",
    key: "description",
    // width: 500,
    className: 'word-break',
    render: (value, row, index) => {
      return <span>
        {row.batch_id && <FilterNone
          className='batch-indicator'
          titleAccess="Batched"
          style={{
            marginRight: 8
          }}
        />}
        {value}
      </span>
    }
  },
  // {
  //     title: "Amount",
  //     dataIndex: "amount",
  //     key: "amount",
  //     width: 120,
  // },
  {
    title: "SOURCE Label",
    dataIndex: "source_id",
    key: "source_id",
    width: 150,
    render: (value, row) => <div
    // className='hoverable-text'
    // onClick={(e) => {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     typeof onSourceClicked === 'function' && onSourceClicked(value)

    // }}
    >
      {value}
    </div>
    // width: 120,
    // render:(value,row,index)=>formatMoney(value, 2, '.', ',')
  }, {
    title: "AMOUNT",
    dataIndex: "amount",
    key: "amount",
    width: 100,
    className: 'right-align',
    render: (value, row, index) => formatMoney(value, 2, '.', ',')
  },
  {
    title: "PROCESSING",
    key: 'reconcilers',
    width: 80,
    render: (row, index) => {
      let unrecon_process = row.unreconciled_groups || []; //["HAHAHA","HAHA","HAHAHAHAHAHA"];
      let total_recon_process = row.reconcilers || [];//["HAHAHA","HUHUHU","HAHA","HUHUHUHU","HAHAHAHAHAHA"];

      return <div style={{
        display: 'flex', flexDirection: 'row',
        width: 40,
        flexWrap: 'wrap'
      }}>
        {total_recon_process.map((item, index) => {
          return <Tooltip className='test-class' arrowPointAtCenter placement='topRight' title={item} key={index} >
            <div
              className={!(unrecon_process.includes(item)) ? 'reconciled-indicator' : 'not-reconciled-indicator'}
            // style={{
            //     width: 12, height: 12, margin: 4, borderRadius: 6,
            //     backgroundColor: THEME_COLORS[!(unrecon_process.includes(item)) ? 'success' : 'error']
            // }}
            ></div>
            {/* <Tag
                                style={{ display: 'flex' }}
                            >
                            <Badge className='faded-text-badge' style={{
                                maxWidth: MAX_RECON_ITEM_WIDTH,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }} status={!(unrecon_process.includes(item)) ? 'success' : 'error'} text={item} /></Tag> */}
          </Tooltip>
        })}
      </div>

    }

  },
  {
    title: "",
    dataIndex: 'id',
    key: 'id',
    width: 40,
    render: (id) => {
      return <MoreHorizOutlined
        titleAccess='View Detail'
        className='basic-icon hand-cursor' onClick={() => {
          console.log("detail clicked")
          typeof onViewDetailClicked === 'function' && onViewDetailClicked(id)
        }} />
    }
  }

]
const aggregated_cols = ({ datatype, onReprocessFile, onDownload, reprocessed_list = [] }) => [
  {
    title: "Created At",
    dataIndex: 'created_at',
    key: 'created_at',
    width: 170,
  },
  {
    title: "File",
    dataIndex: 'file_uri',
    key: 'file_uri',
    className: 'word-break',
    // width: 200,
    render: (file_name, record) => {
      let has_run = record.file_processed === false;
      return <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      }}>
        {file_name ?
          <Link to={`/activity/data-type/${record.data_type_id}/files/${record.id}/view`}>{file_name}</Link> :
          <span>No File Extracted</span>}
        {/* <span>{file_name || "No File Extracted"}</span> */}

        {has_run && !reprocessed_list.includes(record.id) && <Popconfirm
          onConfirm={() => {
            // this.loading_message = message.loading(`Reprocessing ${file_name}`, 0);
            // this.setState({
            //   reprocessing_id: record.id
            // })
            // this.reprocess_file.config({
            //   params: {
            //     response_id: record.fetcher_response_id,
            //     file_id: record.id
            //   }
            // }).execute();
            typeof onReprocessFile === 'function' && onReprocessFile(record)
          }}
          title="Are you sure you want to run this file?">
          <Refresh className='hand-cursor'
            titleAccess="Rerun"
            style={{
              height: 20,
              color: COLORS.primary,
              width: 20,
              // border:'1px solid',
              // borderRadius:'50%',
              marginLeft: 8
            }} /></Popconfirm>}

      </div>
    }

  },
  {
    title: "Pipeline ",
    children: [
      {
        title: "Blocks",
        width: 70,
        key: 'blocks_count',
        dataIndex: 'blocks_count',
        render: (success_count = 0, record) => record.data_type_processed == false ? <span className='right-align'>-</span> :
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end'
          }}>{record.file_processed == false && success_count > 0 ? <Link to={{
            pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
            search: queryString.stringify({
              // success_type:1
            })
          }}>
            <span className='right-align'>{formatMoney(success_count, 0)}</span>
          </Link> :
            <span className='right-align'>{formatMoney(success_count, 0)}</span>
            }</div>
      },
      {
        title: "Parser",
        width: 70,
        key: 'Parser',
        render: (record) => {
          let success_count = record.parsing_success;
          let error_count = record.parsing_error;
          return record.data_type_processed == false ? <span className='right-align'>-</span> : <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end'
          }}>
            {record.file_processed == false && success_count > 0 ? <Link to={{

              pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
              search: queryString.stringify({
                success_type: 1
              })
            }}>
              <span className='right-align'>{formatMoney(success_count, 0)}</span>
            </Link> :
              <span className='right-align'>{formatMoney(success_count, 0)}</span>
            }
            {error_count > 0 && record.file_processed == false &&
              <Link to={{
                pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                search: queryString.stringify({
                  status: 'error',
                  error_type: 1
                })
              }}>
                <span className='error-text'>{formatMoney(error_count, 0)} Errors</span>
              </Link>}</div>
        }
      },
      {
        title: "Normalizer",
        width: 97,
        key: 'Normalizer',
        render: (record) => {
          let success_count = record.normalization_success;
          let error_count = record.normalization_error;
          return record.data_type_processed == false ? <span className='right-align'>-</span> : <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end'
          }}>
            {record.file_processed == false && success_count > 0 ? <Link to={{

              pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
              search: queryString.stringify({
                success_type: 2
              })
            }}>
              <span className='right-align'>{formatMoney(success_count, 0)}</span>
            </Link> :
              <span className='right-align'>{formatMoney(success_count, 0)}</span>
            }
            {error_count > 0 && record.file_processed == false &&
              <Link to={{
                pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                search: queryString.stringify({
                  status: 'error',
                  error_type: 2
                })
              }}>
                <span className='error-text'>{formatMoney(error_count, 0)} Errors</span>
              </Link>}</div>
        }

      },
      {
        title: "Classifier",
        width: 88,
        key: 'Classifier',
        render: (record) => {
          let success_count = record.classification_success;
          let error_count = record.classification_error;
          return record.data_type_processed == false ? <span className='right-align'>-</span> : <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end'
          }}>
            {record.file_processed == false && success_count > 0 ? <Link to={{

              pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
              search: queryString.stringify({
                success_type: 3
              })
            }}>
              <span className='right-align'>{formatMoney(success_count, 0)}</span>
            </Link> :
              <span className='right-align'>{formatMoney(success_count, 0)}</span>
            }
            {error_count > 0 && record.file_processed == false &&
              <Link to={{
                pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                search: queryString.stringify({
                  status: 'error',
                  error_type: 3
                })
              }}>
                <span className='error-text'>{formatMoney(error_count, 0)} Errors</span>
              </Link>}</div>
        }
      },
      {
        title: "Extractor",
        width: 90,
        key: 'Extractor',
        render: (record) => {
          let success_count = record.extraction_success;
          let error_count = record.extraction_error;
          return record.data_type_processed == false ? <span className='right-align'>-</span> : <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end'
          }}>
            {record.file_processed == false && success_count > 0 ? <Link to={{

              pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
              search: queryString.stringify({
                success_type: 4
              })
            }}>
              <span className='right-align'>{formatMoney(success_count, 0)}</span>
            </Link> :
              <span className='right-align'>{formatMoney(success_count, 0)}</span>
            }
            {error_count > 0 && record.file_processed == false &&
              <Link to={{
                pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                search: queryString.stringify({
                  status: 'error',
                  error_type: 4
                })
              }}>
                <span className='error-text'>{formatMoney(error_count, 0)} Errors</span>
              </Link>}</div>
        }
      }, {
        title: "Enricher",
        width: 82,
        key: 'Enricher',
        render: (record) => {
          let success_count = record.enrichment_success;
          let error_count = record.enrichment_error;
          return record.data_type_processed == false ? <span className='right-align'>-</span> : <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end'
          }}>
            {record.file_processed == false && success_count > 0 ? <Link to={{

              pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
              search: queryString.stringify({
                success_type: 5
              })
            }}>
              <span className='right-align'>{formatMoney(success_count, 0)}</span>
            </Link> :
              <span className='right-align'>{formatMoney(success_count, 0)}</span>
            }
            {error_count > 0 && record.file_processed == false &&
              <Link to={{
                pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                search: queryString.stringify({
                  status: 'error',
                  error_type: 5
                })
              }}>
                <span className='error-text'>{formatMoney(error_count, 0)} Errors</span>
              </Link>}</div>
        }
      },
      // {
      //   title: "Transactions",
      //   width: 118,
      //   key: 'Transactions',
      //   dataIndex:'transferred_txns',
      //   render: (success_count=0, record) => {
      //     let error_count = record.txns_count-success_count;
      //     return record.data_type_processed==false? <span className='right-align'>-</span>: <div style={{
      //       display: 'flex',
      //       flexDirection: 'column',
      //       alignItems: 'flex-end'
      //     }}>
      //       {success_count>0?
      //       <Link  to={{
      //         pathname:`/activity/data-type/${record.data_type_id}/transactions`,
      //       }}>
      //       <span className='right-align'>{formatMoney(success_count, 0)}</span>
      //      </Link>
      //   :<span className='right-align'>{formatMoney(success_count,0)}</span> 
      //   }
      //       {error_count > 0 &&
      //         <Link  to={{
      //           pathname:record.file_processed==true?`/activity/data-type/${record.data_type_id}/nottransferredtransactions`:
      //           `/activity/data-type/${record.data_type_id}/files/${record.id}`
      //           ,
      //           search: queryString.stringify({
      //             // fetcher_response_id:record.fetcher_response_id,
      //             // dateFrom:record.file_processed==true?record.min_txn_date:null,
      //             // dateTo:record.file_processed==true?record.max_txn_date:null,
      //             parse_batch_id:record.file_processed==true?record.id:null,

      //           })
      //         }}>
      //           <span className='error-text'>{formatMoney(error_count, 0)} 
      //           {record.file_processed==true?" Queued":" Blocks"}</span>
      //         </Link>}</div>
      //   }

      // }
    ]
  },
  {
    title: "Packets",
    children: [
      {
        title: "Queued",
        width: 70,
        key: 'queued_packets',
        dataIndex: 'queued_packets',
        render: (value, record) => <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end'
        }}>{record.data_type_processed == false ? <span className='right-align'>-</span> : value > 0 ? <Link to={{
          pathname: `/activity/data-type/${record.data_type_id}/packets`,
          search: queryString.stringify({
            transferred: 'false',
            fetcher_response_id: record.fetcher_response_id
          })
        }}> <span className='right-align'>{formatMoney(value, 0)}</span></Link> : <span className='right-align'>{formatMoney(value, 0)}</span>
          }</div>
      },
      {
        title: "Transferred",
        width: 95,
        key: 'transferred_packets',
        dataIndex: 'transferred_packets',
        render: (value, record) => <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end'
        }}>{record.data_type_processed == false ? <span className='right-align'>-</span> : value > 0 ? <Link to={{
          pathname: `/activity/data-type/${record.data_type_id}/packets`,
          search: queryString.stringify({
            transferred: 'true',
            fetcher_response_id: record.fetcher_response_id
          })
        }}> <span className='right-align'>{formatMoney(value, 0)}</span></Link> : <span className='right-align'>{formatMoney(value, 0)}</span>
          }</div>

      },
      {
        title: "Total",
        width: 60,
        key: 'total_packets',
        dataIndex: 'total_packets',
        render: (value, record) => <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end'
        }}>{record.data_type_processed == false ? <span className='right-align'>-</span> :
          value > 0 ? <Link to={{
            pathname: `/activity/data-type/${record.data_type_id}/packets`,
            search: queryString.stringify({
              fetcher_response_id: record.fetcher_response_id
            })
          }}>  <span className='right-align'>{formatMoney(value, 0)}</span></Link> : <span className='right-align'>{formatMoney(value, 0)}</span>
          }</div>
      }
    ]
  },
  // {
  //   title: "File",
  //   dataIndex: 'file_uri',
  //   key: 'file_uri',
  // },
  // {
  //   title: "Packets Count",
  //   dataIndex: 'packets_count',
  //   key: 'packets_count',
  //   width:100,
  //   className:'right-align',
  //   render: (value, record) => {
  //     return value?<Link className='right-flex-child' to={{
  //       pathname:`/activity/data-type/${datatype}/packets`,
  //       search:queryString.stringify({
  //         fetcher_response_id:record.fetcher_response_id,
  //         file_uri:record.file_uri,
  //         // dateFrom:moment(record.created_at,"YYYY-MM-DD HH:mm:ss A").isValid()?moment(record.created_at,"YYYY-MM-DD").format("YYYY-MM-DD"):null,
  //         // dateTo:moment(record.created_at,"YYYY-MM-DD HH:mm:ss A").isValid()?moment(record.created_at,"YYYY-MM-DD").add({day:1}).format("YYYY-MM-DD"):null,

  //       })
  //     }}>{formatMoney(value,0)}</Link>:(value||"-")
  //   }
  // },
  // {
  //   title: "Blocks Count",
  //   dataIndex: 'blocks_count',
  //   key: 'blocks_count',
  //   width:100,
  //   render: (value, record) => {
  //   return <div style={{
  //     display:'flex',
  //     flexDirection:'column',
  //     alignItems:'flex-end'
  //   }}>
  //     {record.failed_count? <Link  to={{
  //       pathname:`/activity/data-type/${datatype}/files/${record.id}`,
  //     }}>
  //       <span className='right-align'>{formatMoney(value,0)}</span>
  //     </Link>:
  //     <span className='right-align'>{formatMoney(value,0)}</span>
  //   }
  //     {record.failed_count>0&&
  //     <Link  to={{
  //       pathname:`/activity/data-type/${datatype}/files/${record.id}`,
  //       search:queryString.stringify({
  //         status:'error'
  //       })
  //     }}>
  //     <span className='error-text'>{formatMoney(record.failed_count,0)} Failed</span>
  //   </Link>}</div>
  //   }
  // },

  {
    title: "Actions",
    key: 'actions',
    className: 'center-align',
    width: 100,
    render: (record, data) => {
      return <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: 16,
        paddingRight: 16,
        justifyContent: 'center'
      }}>
        <GetAppOutlined titleAccess="Download File"
          onClick={() => {
            typeof onDownload === 'function' && onDownload(record)
          }}
          className='basic-icon hand-cursor' />
        <Divider type='vertical' />
        <Link to={{
          pathname: `/activity/fetcher/responses/${record.fetcher_log_id}/${record.fetcher_response_id}`,
          // search: queryString.stringify({
          //   file_uri: record.file_uri,
          //   fetcher_response_id: record.fetcher_response_id,
          //   data_selector_id: record.data_selector_id
          // })
        }}>
          <AssignmentReturn
            titleAccess='Go To Response'
            className='basic-icon hand-cursor'
          // onClick={() => {
          //     console.log("detail clicked")
          //     typeof onViewclicked === 'function' && onViewclicked(id)
          // }} 
          /></Link>

        {/* <Link to={{
        pathname:`/activity/data-type/${datatype}/files/${record.id}/view`}}
        >
        <Button title="View File"
          onClick={() => {
          }}
          style={{
            padding: 0
          }} type='link'>View</Button>
          </Link>
        <Divider type='vertical' /> */}

        {/* <Button title="Rerun"
        disabled={record.processed}
          onClick={() => {
            if(record.processed){
              notification.warn({
                message:"You cannot re-run this file now."
              })
            }else{
              typeof onReprocess==='function'&&onReprocess(record)
            }
          }}
          style={{
            padding: 0
          }} type='link'>Re-run</Button>
       */}

      </div>
    }
  }
]

class UnclassifiedTransactionList extends Component {
  constructor(props) {
    super(props)

    this.datatype = props.match.params.datatype_id;

    this.state = {
      filter_query: {
        per_page: 100,
        page: 1,
        // dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
        // dateTo: moment().format(defaultDateFormat),
      },

      selected_data: [],
      datatype: this.datatype,
      datatype_obj: {},

      form_data: {},
      form_visibility: false,

      loading: true,
    };

    this.datatype_detail = RESTExecutor.detail().config({
      label: 'datatypes_details'
    }).callbacks((success) => {
      this.setState({ loading: false, datatype_obj: success.result })
      this.list_transactions.forId(this.datatype).config({
        params: {
          ...this.state.filter_query
        }
      }).execute();
    }, (error) => {
      showErrorInNotification(error);
      this.setState({ loading: false })
    }).forId(this.state.datatype).connect(props.domains.allData)


    this.list_transactions = RESTExecutor.list().config({
      label: 'unclassified_transaction',
      params: {
        ...this.state.filter_query
      }
    }).forId(this.state.datatype).connect(props.domains.allData);

    this.classify_transactions = RESTExecutor.post().config({
      label: 'classify_service'
    }).callbacks((success) => {
      message.success(`${this.state.selected_data.length} Transaction Classified`);
      this.list_transactions.execute();
      this.setState({
        form_data: {},
        selected_data: [],
        form_visibility: false
      })

    }, (error) => {
      showErrorInNotification(error);
    }).connect(props.domains.allData);



    // this.list_transactions.execute();


  }

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }


  render() {
    let list_transactions_resp = this.list_transactions.response();// this.list_datatypes.response();
    let list_transactions_data = list_transactions_resp.result || {};
    let datatype_detaile_resp = this.datatype_detail.response()

    if (this.state.loading) {
      return <center><Spin /></center>
    }
    let rowsData = list_transactions_data.rows || [];
    let rowsMeta = list_transactions_resp.meta || {};


    console.log("rows meta", rowsMeta)
    let classify_response = this.classify_transactions.response();



    const { filter_query, selected_data } = this.state;



    return (
      <ErrorWrapper
        error={datatype_detaile_resp}
        onReload={() => {
          this.datatype_detail.execute()
        }}
      >


        <BasicHeader
          title={this.state.datatype_obj.name}
          titleType="Datatype"
          subtitle="Unclassified Transactions"
          subtitleStyle={{
            color: COLORS.danger_primary
          }}
          right={[
            <Link to={`/activity/data-type/${this.datatype}/transactions`} >
              <TransparentButton
                label="Transactions"
                icon={<StorageOutlined />}
                hint="View Transactions"
              />
            </Link>,
            <Link to={`/activity/data-type/${this.datatype}/packets`} >
              <TransparentButton
                label="Packets"
                icon={<LayersOutlined />}
                hint="View Packets"
              />
            </Link>,
            <Link to={`/activity/data-type/${this.datatype}/sources`} >
              <TransparentButton
                label="Sources"
                icon={<WifiTetheringOutlined />}
                hint="View Sources"
              />
            </Link>,
            <Link to={`/activity/data-type/${this.datatype}/files`} >
              <TransparentButton
                label="Files"
                icon={<WifiTetheringOutlined />}
                hint="View Files"
              />
            </Link>
            // <Button type='primary' onClick={() => {
            //   this.setState({
            //     upload_form_visibility: true
            //   })
            // }} style={{ margin: 4 }} icon='file' key="3">Upload File</Button>
          ]}
        />

        <div className='filter-card'>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            flexWrap: 'nowrap',
            paddingTop: 4, paddingBottom: 12
          }}>
            <Input.Search
              placeholder="Input search text"
              // enterButton
              allowClear
              autoFocus
              value={filter_query.query}
              style={{}}
              onChange={(e) => {
                e.stopPropagation();
                e.preventDefault()
                this.stateUpdater({
                  stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {
                    this.delay_search.onSearch(() => {
                      this.props.history.push({
                        search: queryString.stringify({ ...this.state.filter_query, page: 1 })
                      })
                    })
                  }
                });
              }}
            />
            <CustomDateRangePicker
              style={{
                width: 400,
                marginLeft: 16,
                flex: null
              }}
              startDate={moment(filter_query.dateFrom, defaultDateFormat)}
              endDate={moment(filter_query.dateTo, defaultDateFormat)}
              onChange={(dates) => {
                //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                this.stateUpdater({
                  stateKey: 'filter_query', appendObj: {
                    dateFrom: dates.startDate.format(defaultDateFormat),
                    dateTo: dates.endDate.format(defaultDateFormat), page: 1
                  },
                  callback: () => {
                    this.props.history.push({
                      search: queryString.stringify(this.state.filter_query)
                    })
                    // this.list_transaction.config({
                    //     params: {
                    //         ...this.getParams(),
                    //         per_page:20,
                    //         page:1
                    //     }
                    // }).execute()
                  }
                })

                // this.setState({
                //     startDate: dates.startDate,
                //     endDate: dates.endDate
                // })
              }}

            />
          </div>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            // justifyContent: 'space-between',
            // flexWrap: 'nowrap',
            paddingTop: 4, paddingBottom: 4,
            // paddingLeft: 8, paddingRight: 8
          }}>
            <FilterFixedInput label="Source Label">
              <NetworkSelect
                value={filter_query.source}
                style={{ marginRight: 8 }}
                item={{ name: "Source Label", display_key: 'source_id', item_key: "source_id", className: filter_query.source != null ? 'filter-option-selected' : '' }}
                url={`/my-data-types/${this.datatype}/staging-info/source-labels`}
                onChange={(received_value) => {
                  this.stateUpdater({
                    stateKey: 'filter_query',
                    valueKey: 'source',
                    value: received_value,
                    callback: () => {
                      this.props.history.push({
                        search: queryString.stringify({ ...this.state.filter_query, page: 1 })
                      })
                    }
                  })
                  // this._change(item.index, received_value, d_key)
                }}
              // renderItem={(data)=>{
              //     // console.log("data",data)
              //     let ref = data.__references__ || {};
              //     let source = ref.source_id || {};
              //     return source.name
              //   }}

              /></FilterFixedInput>
            <FilterFixedInput label="Txn Type">
              <Select
                allowClear
                className={filter_query.txn_type != null ? 'filter-option-selected' : ''}
                showSearch
                style={{
                  marginRight: 8,
                  width: '100%'
                }}
                // style={{ marginTop:4,marginBottom:4 }}
                placeholder="Txn Type"
                value={filter_query.txn_type}
                // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                onChange={(value, e) => {
                  this.stateUpdater({
                    stateKey: 'filter_query',
                    valueKey: 'txn_type',
                    value: value,
                    callback: () => {
                      this.props.history.push({
                        search: queryString.stringify({ ...this.state.filter_query, page: 1 })
                      })
                    }
                  });
                }}
              >
                <Select.Option value={"D"} key={"D"}>
                  Debit
                </Select.Option>
                <Select.Option value={"C"} key={"C"}>
                  Credit
                </Select.Option>
                <Select.Option value={"N/A"} key={"N/A"}>
                  N/A
                </Select.Option>
              </Select>
            </FilterFixedInput>
            {/* <FilterFixedInput label="Date Range">
              <CustomDateRangePicker
                style={{
                  // margin: 4,
                  // width: 400
                }}
                startDate={filter_query.dateFrom ? moment(filter_query.dateFrom, defaultDateFormat) : null}
                endDate={filter_query.dateTo ? moment(filter_query.dateTo, defaultDateFormat) : null}
                onChange={(dates) => {
                  //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                  this.stateUpdater({
                    stateKey: 'filter_query', appendObj: {
                      dateFrom: dates.startDate.format(defaultDateFormat),
                      dateTo: dates.endDate.format(defaultDateFormat)
                    },
                    callback: () => {
                      this.props.history.push({
                        search: queryString.stringify({ ...this.state.filter_query, page: 1 })
                      })
                    }
                  });
                }}
              />
            </FilterFixedInput> */}
          </div>

          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            // flexWrap: 'nowrap',
            paddingTop: 4, paddingBottom: 4,
            // paddingLeft: 8, paddingRight: 8
          }}>
            <CustomButton
              disabled={selected_data.length == 0}
              style={{
                width: '100%',

              }}
              className='success-btn'
              onClick={() => {
                this.setState({
                  form_visibility: true
                })
              }}
              label={selected_data.length > 0 ? `CLASSIFY ${selected_data.length} TRANSACTION(S)` : "CLASSIFY"}
            />

          </div>
        </div>

        <ErrorWrapper
          error={list_transactions_resp}
          onReload={() => {
            this.list_transactions.execute()
          }}
        >
          <PopUpForm
            width="60%"
            key={`${this.datatype}services`}
            title={"SELECT SERVICE"}
            show_title_only
            forCreate={true}
            initialData={this.state.form_data}
            fields={[{
              index: 'service_id',
              type: 'networkselect',
              url: `/my-data-types/${this.datatype}/services`
            }]}
            open={this.state.form_visibility}
            networkState={classify_response}
            onClose={() => {
              console.log("closing upload form")
              this.setState({
                form_visibility: false,
                form_data: {}
              })
            }
            }
            onSubmit={(data) => {
              console.log("DATA", data);
              this.classify_transactions.execute({
                ...data,
                data_type_id: this.datatype,
                txn_ids: selected_data
              })
              // this.reRun(data);
            }}
          />
          <Modal
            visible={this.state.view_transaction_modal}
            width={'90%'}
            destroyOnClose
            footer={null}
            className='transaction-modal'
            centered
            onCancel={() => {
              this.setState({
                view_transaction_modal: false,
                view_transaction_id: null
              })
            }}
          >
            <ModalTransactionDetail
              isModal={true}
              onClose={() => {
                this.setState({
                  view_transaction_modal: false,
                  view_transaction_id: null
                })
              }}
              match={{
                params: {
                  transaction_id: this.state.view_transaction_id
                }
              }}
            />
          </Modal>

          <div className='default-card' style={{
            // padding: 8
          }}>
            <Table
              // rowClassName='hand-cursor'
              className='main-table'
              loading={list_transactions_resp.fetching}
              size='small'
              rowClassName={(record) => {
                let total_reconcilers = record.reconcilers || [];
                let unreconciled_rec = record.unreconciled_groups || [];
                let disabled = false;
                if (total_reconcilers.length != unreconciled_rec.length && total_reconcilers.length > 0) {
                  return 'error-row';
                }
              }}
              scroll={{ x: true }}
              expandedRowRender={(record, index, indent, expanded) => {
                let ours = record || {};
                return <div key={record.id} style={{ display: 'flex', flexDirection: 'column', paddingBottom: 16 }}>
                  <div>
                    {ours.parsed_data && Object.keys(ours.parsed_data).length > 0 &&
                      <Descriptions title="Parsed Data" className='small-description' bordered size='small' layout='horizontal'>
                        {Object.keys(ours.parsed_data).map((key) => {
                          return <Descriptions.Item key={key} label={key}>{typeof ours.parsed_data[key] === 'string' ? ours.parsed_data[key] : JSON.stringify(ours.parsed_data[key])}</Descriptions.Item>
                        })}
                      </Descriptions>

                    }
                  </div>
                </div>
              }}
              pagination={{
                // simple: true,
                position: 'bottom',
                onChange: (current, size) => {
                  this.props.history.push({
                    search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                  })
                },
                defaultCurrent: 1,
                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                defaultPageSize: 100,
                pageSize: (rowsMeta && rowsMeta.requested_count),

                total: (rowsMeta && rowsMeta.total_count > 10000 ? 10000 : rowsMeta.total_count),
                showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${rowsMeta.total_count > 10000 ? `10,000+` : formatMoney(rowsMeta.total_count, 0)} items`
              }}
              bordered={true}

              rowSelection={{
                onChange: (selected_row_keys, selectedRows) => {
                  console.log("selectedf", selected_row_keys, selectedRows)
                  this.setState({
                    selected_data: selected_row_keys
                  })
                },
                selectedRowKeys: selected_data,
                getCheckboxProps: (record) => {
                  let total_reconcilers = record.reconcilers || [];
                  let unreconciled_rec = record.unreconciled_groups || [];
                  let disabled = false;
                  if (total_reconcilers.length != unreconciled_rec.length && total_reconcilers.length > 0) {
                    disabled = true;
                  }
                  return {
                    disabled: disabled,

                  }
                }
              }}
              rowKey={(record) => record.id}
              columns={transaction_cols_new({
                onServiceClicked: (received_value) => {
                  this.stateUpdater({
                    stateKey: 'main_query',
                    valueKey: 'service',
                    value: `${received_value}`,
                    callback: () => {
                      this.props.history.push({
                        search: queryString.stringify({ ...this.state.main_query, per_page: 100, page: 1 })
                      })
                    }
                  })
                },
                onViewDetailClicked: (id) => {
                  this.setState({
                    view_transaction_modal: true,
                    view_transaction_id: id
                  })
                },
                onSourceClicked: (received_value) => {
                  this.stateUpdater({
                    stateKey: 'main_query',
                    valueKey: 'source',
                    value: `${received_value}`,
                    callback: () => {
                      this.props.history.push({
                        search: queryString.stringify({ ...this.state.main_query, per_page: 100, page: 1 })
                      })
                    }
                  })
                }
              })}
              dataSource={rowsData}
            />
          </div>
        </ErrorWrapper>
      </ErrorWrapper>
    );
  }

  componentDidMount() {

    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 100,
        page: 1,
        dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
        dateTo: moment().format(defaultDateFormat),
        datatype: this.datatype,
        ...new_filter_query
      }
    }, () => {
      this.datatype_detail.execute()
      // this.list_packets.config({
      //     params: {
      //     ...this.state.filter_query
      //     }
      // }).execute()
    })
  }

  componentWillUnmount() {
    try {
      this.loading_message();
    } catch (e) {

    }
  }
  componentWillReceiveProps(nextProps) {
    var olddatatype_id = this.props.match.params.datatype_id;
    var newdatatype_id = nextProps.match.params.datatype_id;


    if (olddatatype_id !== newdatatype_id || (
      this.props.location && (this.props.location.search !== nextProps.location.search)
    )) {
      this.datatype = newdatatype_id;
      const parsed = queryString.parse(nextProps.location.search);
      this.setState({
        filter_query: {
          per_page: 100,
          page: 1,
          datatype: this.datatype,
          dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
          dateTo: moment().format(defaultDateFormat),
          ...parsed
        },
        selected_data: [],
      }, () => {
        if (olddatatype_id !== newdatatype_id) {
          this.setState({
            loading: true
          }, () => {
            this.datatype_detail.forId(this.datatype).execute()
          })
        } else {
          this.list_transactions.forId(this.datatype).config({
            params: {
              ...this.state.filter_query
            }
          }).execute()
        }
      })

    }
  }
}

export default UnclassifiedTransactionList = withDomains(UnclassifiedTransactionList, "allData", "datatype");

